const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/pages/plot/PlotHome.vue')
const routes = [
    {
        path: '/plot',
        component: EntityHome,
        meta: { breadCrumb: 'Plot Lines', entity: 'plot' },
        children: [
            {
                path: '',
                name: 'plot',
                component: () => import('@/pages/plot/PlotList.vue'),
                meta: { breadCrumb: 'List' },
            },
            {
                path: 'archive',
                name: 'plotArchive',
                component: () => import('@/pages/plot/Archive.vue'),
                meta: { breadCrumb: 'List' },
            },
            {
                path: 'filter/:teamId?',
                name: 'filterPlot',
                component: () => import('@/pages/plot/PlotList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newPlot',
                component: () => import('@/pages/plot/Editor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editPlot',
                component: () => import('@/pages/plot/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readPlot',
                component: () => import('@/pages/plot/Reader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
        ],
    },
]

export default routes
